var Switch_module_default = { toggle: "_toggle_13rnk_9" };
//#endregion
export { Switch_module_default as default };

//# sourceMappingURL=Switch.module.js.map